import { Component, OnInit, Input } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { constants, KeyBoardCodes } from "../../constants/constants";

@Component({
  selector: "app-category-type",
  templateUrl: "./category-type.component.html",
  styleUrls: ["./category-type.component.css"]
})
export class CategoryTypeComponent implements OnInit {
  @Input() category;
  @Input() categoryCtl: UntypedFormControl;

  constructor() {}

  ngOnInit() {
    this.onChanges();
  }
  onlyNumbersWithDot(e: any): boolean {
    let charCode;
    if ((e.keyCode > 0) || (typeof e.charCode !== constants.UNDEFINED)) {
      charCode = e.which || e.keyCode;
    }
    if (charCode === KeyBoardCodes.DELETE) {
      return true;
    }
    if (charCode > KeyBoardCodes.UNIT_SEPERATOR && (charCode < KeyBoardCodes.ZERO || charCode > KeyBoardCodes.NINE)) {
      return false;
    }
    return true;
  }

  onChanges() {
    this.categoryCtl.valueChanges.subscribe(val => {
      this.category.value = val;
    });
  }
}
